// extracted by mini-css-extract-plugin
export var base = "_4f-0";
export var updateBanner = "_4f-1";